import { render, staticRenderFns } from "./ClosingMinute.vue?vue&type=template&id=fa836f78"
import script from "./ClosingMinute.vue?vue&type=script&lang=js"
export * from "./ClosingMinute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports